import React, { useState } from "react"
import contact1 from "./contact1.png"
import "./Contact.css"
import {ImLinkedin} from "react-icons/im"
import {FaGithubSquare} from "react-icons/fa"
const Contact = () => {
  const [data, setData] = useState({
    fullname: "",
    phone: "",
    email: "",
    subject: "",
    message: "",})

  const InputEvent = (event) => {
    const { name, value } = event.target

    setData((preVal) => {
      return {
        ...preVal,
        [name]: value,
      }
    })
  }

  // const formSubmit = (event) => {
  //   event.preventDefault()
  //   alert(
  //     `My name is ${data.fullname}. 
	// My phone number is ${data.phone}. 
	// My email address is ${data.email}. 
	// My Subject on  ${data.subject}. 
	// Here is my message I want to say : ${data.message}. 
	// `
  //   )
  // }
  return (
    <div style={{marginBottom:'100px'}}>
      <section className='Contact' id='contact'>
        <div className='container top'>
          <div className='heading text-center'>
            <h4>CONTACT</h4>
            <h1>Contact Me</h1>
          </div>

          <div className='content d_flex'>
            <div className='left'>
              <div className='box box_shodow'>
                <div className='img'>
                  <img src={contact1} alt='' style={{width:"100%"}} />
                </div>
                <div className='details'>
                  <h1>Niranjan Salunkhe</h1>
                  <p>Aspiring Full Stack web Developer</p>
                  <p>From Masai School Bangalore</p> <br />
                  <p>Mob: 8830572879</p>
                  <p>Email: niranjansalunkhe007@gmail.com</p> <br />
                  <span>Contact </span>
                  <div className='button f_flex'>
                  <div className='button'>
                  <a href="https://www.linkedin.com/in/niranjan-salunkhe/" target="_blank" rel="noopener noreferrer">
                  <button className='btn_shadow'>   
                  <ImLinkedin fontSize={30}/>
                  </button>
                  </a>
                  <a href="https://github.com/nsalunkhe" target="_blank" rel="noopener noreferrer">
                  <button className='btn_shadow'>
                    <FaGithubSquare fontSize={30}/>
                  </button>
                  </a>
                </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='right box_shodow'>
              <form  action="https://getform.io/f/dba5b15c-db5e-49b1-a29a-e6dbbaf33c26" method="POST" >
                <div className='f_flex'>
                  <div className='input row'>
                    <span>YOUR NAME</span>
                    <input type='text' name='fullname' value={data.fullname} onChange={InputEvent} />
                  </div>
                  <div className='input row'>
                    <span>PHONE NUMBER </span>
                    <input type='number' name='phone' value={data.phone} onChange={InputEvent} />
                  </div>
                </div>
                <div className='input'>
                  <span>EMAIL </span>
                  <input type='email' name='email' value={data.email} onChange={InputEvent} />
                </div>
                <div className='input'>
                  <span>SUBJECT </span>
                  <input type='text' name='subject' value={data.subject} onChange={InputEvent} />
                </div>
                <div className='input'>
                  <span>YOUR MESSAGE </span>
                  <textarea cols='30' rows='10' name='message' value={data.message} onChange={InputEvent}></textarea>
                </div>
                <button className='btn_shadow'>
                  SEND MESSAGE <i className='fa fa-long-arrow-right'></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Contact